export class AreaType {
  private constructor(readonly name: string, readonly code: string) {}

  static all(): AreaType[] {
    return [
      new AreaType('国内', 'local'),
      new AreaType('北海道', 'hokkaido'),
      new AreaType('青森県', 'aomori_prefecture'),
      new AreaType('岩手県', 'iwate_prefecture'),
      new AreaType('宮城県', 'miyagi_prefecture'),
      new AreaType('秋田県', 'akita_prefecture'),
      new AreaType('山形県', 'yamagata_prefecture'),
      new AreaType('福島県', 'fukushima_prefecture'),
      new AreaType('茨城県', 'ibaraki_prefecture'),
      new AreaType('栃木県', 'tochigi_prefecture'),
      new AreaType('群馬県', 'gunma_prefecture'),
      new AreaType('埼玉県', 'saitama_prefecture'),
      new AreaType('千葉県', 'chiba_prefecture'),
      new AreaType('東京都', 'tokyo'),
      new AreaType('神奈川県', 'kanagawa_prefecture'),
      new AreaType('新潟県', 'niigata_prefecture'),
      new AreaType('富山県', 'toyama_prefecture'),
      new AreaType('石川県', 'ishikawa_prefecture'),
      new AreaType('福井県', 'fukui_prefecture'),
      new AreaType('山梨県', 'yamanashi_prefecture'),
      new AreaType('長野県', 'nagano_prefecture'),
      new AreaType('岐阜県', 'gifu_prefecture'),
      new AreaType('静岡県', 'shizuoka_prefecture'),
      new AreaType('愛知県', 'aichi_prefecture'),
      new AreaType('三重県', 'mie_prefecture'),
      new AreaType('滋賀県', 'shiga_prefecture'),
      new AreaType('京都府', 'kyoto_prefecture'),
      new AreaType('大阪府', 'osaka_prefecture'),
      new AreaType('兵庫県', 'hyōgo_prefecture'),
      new AreaType('奈良県', 'nara_prefecture'),
      new AreaType('和歌山県', 'wakayama_prefecture'),
      new AreaType('鳥取県', 'tottori_prefecture'),
      new AreaType('島根県', 'shimane_prefecture'),
      new AreaType('岡山県', 'okayama_prefecture'),
      new AreaType('広島県', 'hiroshima_prefecture'),
      new AreaType('山口県', 'yamaguchi_prefecture'),
      new AreaType('徳島県', 'tokushima_prefecture'),
      new AreaType('香川県', 'kagawa_prefecture'),
      new AreaType('愛媛県', 'ehime_prefecture'),
      new AreaType('高知県', 'kochi_prefecture'),
      new AreaType('福岡県', 'fukuoka_prefecture'),
      new AreaType('佐賀県', 'saga_prefecture'),
      new AreaType('長崎県', 'nagasaki_prefecture'),
      new AreaType('熊本県', 'kumamoto_prefecture'),
      new AreaType('大分県', 'oita_prefecture'),
      new AreaType('宮崎県', 'miyazaki_prefecture'),
      new AreaType('鹿児島県', 'kagoshima_prefecture'),
      new AreaType('沖縄県', 'okinawa_prefecture'),
      new AreaType('海外', 'foreign'),
    ];
  }
}
